import type { RouteRecordRaw } from 'vue-router'

// Async shell (see shellRegistry): keeps the chat subtree out of this path's
// chunks. The router doesn't await async components, matching render-time
// resolution — do not swap for a static AppShell-style import.
import { DialerAppShellAsync } from './shellRegistry'
import HumanDialerQueuePage from './views/HumanDialerQueuePage.vue'
import DialerHistoryPage from './views/DialerHistoryPage.vue'
import PhoneSettingsPage from './views/PhoneSettingsPage.vue'
import IntegrationsPage from './views/IntegrationsPage.vue'
import UsersPage from './views/UsersPage.vue'
import ProfilePage from './views/ProfilePage.vue'

export const DIALER_ONLY_HOME = '/dialer/human'

/**
 * Route table active for ``access_mode === 'dialer_only'`` tenants. The table
 * IS the access allowlist: anything not declared here doesn't exist, and the
 * catch-all lands on the dialer. Children reuse the SAME components, names,
 * paths, and meta as their nextRoutes counterparts so URLs stay identical
 * across cohorts (pinned by router-dialer.test.ts).
 */
export const dialerOnlyRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: DialerAppShellAsync,
    children: [
      { path: '', redirect: DIALER_ONLY_HOME },
      {
        path: '/dialer/human',
        name: 'human-dialer',
        component: HumanDialerQueuePage,
        meta: { requiresAuth: true, title: 'Dialer' },
      },
      {
        path: '/dialer/history',
        name: 'dialer-history',
        component: DialerHistoryPage,
        meta: { requiresAuth: true, title: 'Dialer history' },
      },
      {
        path: '/settings/phone',
        name: 'phone-settings',
        component: PhoneSettingsPage,
        meta: { requiresAuth: true, title: 'Phone Settings' },
      },
      {
        path: '/settings/users',
        name: 'users',
        component: UsersPage,
        meta: { requiresAuth: true, title: 'Users' },
      },
      {
        path: '/integrations',
        name: 'integrations',
        component: IntegrationsPage,
        meta: { requiresAuth: true, title: 'Integrations' },
      },
      // Stale links/bookmarks into the per-CRM drawer, same as nextRoutes.
      { path: '/crm-settings', redirect: '/integrations' },
      { path: '/activity-mappings', redirect: '/integrations' },
      {
        path: '/profile',
        name: 'profile',
        component: ProfilePage,
        meta: { requiresAuth: true, title: 'Profile' },
      },
      { path: ':pathMatch(.*)*', redirect: DIALER_ONLY_HOME },
    ],
  },
]
